import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // ES6

class BlogEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { text: "" }; // You can also pass a Quill Delta here
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({ text: this.props.text });
  }

  handleChange(value) {
    this.setState({ text: value });
    this.props.onChange(value, this.quillRef.getEditor().getText());
  }

  render() {
    return (
      <ReactQuill
        ref={el => (this.quillRef = el)}
        value={this.state.text}
        onChange={this.handleChange}
      />
    );
  }
}

export default BlogEditor;



// WEBPACK FOOTER //
// ./src/components/BlogEditor/index.js